"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.axios = void 0;
var _axios = _interopRequireDefault(require("axios"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/* eslint-disable no-undef */

const axios = exports.axios = _axios.default.create();
axios.interceptors.request.use(config => {
  let grant;
  try {
    grant = JSON.parse(localStorage.getItem('grant') || '{}');
  } catch (error) {
    grant = false;
  }
  if (grant && grant.access_token) {
    config.headers.common.Authorization = `Bearer ${grant.access_token}`;
  }
  return config;
}, error => Promise.reject(error));
var _default = exports.default = axios;
//# sourceMappingURL=axios.js.map